<template>
    <v-card>
        <v-card-title class="pb-0 pt-1" >
            <v-icon style="background: #e7e8e9; padding: 10px!important; border-radius: 50%;" class="mr-4">mdi-file-document-outline</v-icon>
            <span >Nueva Nota</span>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="6" md="4">
                <v-autocomplete :rules="[v => !!v || 'Campo requerido']" clearable v-model="note.to_user_id" :items="usersLists" label="Para" item-text="name" item-value="id">
                    <template slot="no-data" class="pa-2">No existen usuarios relacionados.</template>                      
                </v-autocomplete>
            </v-col>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0">
            <v-container>
                <!--v-row>
                    <v-col class="py-0" cols="12" sm="6" md="6">
                        <v-autocomplete
                            @keydown.enter.stop
                            clearable
                            v-model="note.company_id"
                            :items="companyLists"
                            :loading="isLoadingCompany"
                            :search-input.sync="searchCompanies"
                            :hide-no-data="!searchCompanies"
                            item-value="id"
                            item-text="name"
                            label="Empresa"
                            placeholder="Escribe para buscar"
                            attach
                        >
                            <template v-slot:item="{item, attrs, on}">
                                <v-list-item v-on="on" v-bind="attrs">
                                    <v-list-item-content>
                                        <v-list-item-title v-if="item.name!=null">
                                            <span v-if="item.macro!=null">{{item.macro}}</span>{{item.name}}
                                            <div v-if="item.razon_social!=null">
                                                <span style="font-size:12px;">{{item.razon_social}}</span>
                                            </div>
                                        </v-list-item-title>
                                        <v-list-item-title v-else-if="item.razon_social!=null">
                                            {{item.razon_social}}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                            <template slot="no-data"><div class="px-4 py-1">No existen empresas relacionadas. <v-btn rounded class="mx-3" color="primary" @click="createCompanyDialog=true" x-small>Crear</v-btn></div></template>
                        </v-autocomplete>
                    </v-col>
                    <v-col class="py-0" cols="12" sm="6" md="6">
                        <v-autocomplete
                            :disabled="note.company_id==null"
                            clearable
                            v-model="note.contact_id"
                            :items="contactLists"
                            :loading="isLoadingContact"
                            :search-input.sync="searchContacts"
                            :hide-no-data="!searchContacts"
                            item-value="id"
                            item-text="name"
                            label="Contacto"
                            placeholder="Escribe para buscar"
                            attach
                        >
                            <template v-slot:item="{item, attrs, on}">
                                <v-list-item v-on="on" v-bind="attrs">
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{item.name}} <span v-if="item.last!=undefined">{{item.last}}</span>
                                            <div>
                                                <span style="font-size:12px;">{{item.company}}</span>
                                            </div>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                            <template slot="no-data"><div class="px-4 py-1">No existen contactos relacionados. <v-btn rounded class="mx-3" color="primary" @click="createContactDialog=true" x-small>Crear</v-btn></div></template>
                        </v-autocomplete>
                    </v-col> 
                </v-row-->
                <v-container fluid>
                    <v-textarea v-model="note.comment" label="Nota"></v-textarea>
                </v-container>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">
                Cancelar
            </v-btn>
            <v-btn color="blue darken-1" :loading="gris" :disabled="gris || !valid" text @click="save">
                Guardar
            </v-btn>
        </v-card-actions>

        <!-- Crear Contacto -->
        <v-dialog v-model="createContactDialog" max-width="600px">
            <createContact v-bind:company="note.company_id" @closeCreateDialogContact="closeCreateDialogContact"/>
        </v-dialog>
        <!-- Crear empresa -->
        <v-dialog v-model="createCompanyDialog" max-width="700px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn bottom color="#e25200" dark fab fixed right v-bind="attrs" v-on="on">
                <v-icon color="white">  mdi-plus </v-icon>
            </v-btn> 
          </template>
          <createCompany @closeCreateDialogCompany="closeCreateDialogCompany"/>
        </v-dialog>

        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-card>
</template>

<script>
import axios from "axios";
import CreateContact from "../clients/contacts/create"
import CreateCompany from "../clients/companies/create"
    export default {
        components: {
            'createContact':CreateContact,
            'createCompany':CreateCompany,
        }, 
        props:{
            company:[String, Object]
        },  
        data: () => ({
            snackbar: {
                show: false,
                message: null,
                color: null
            },
            gris: false,
            createContactDialog: false,
            createCompanyDialog: false,
            entries:{
                companies:[],
                contacts:[]
            },
            isLoadingCompany: false,
            isLoadingContact: false,
            searchCompanies: null,
            searchContacts: null,
            note:{
                company_id:null,
                contact_id:'',
                from_user_id:'',
                to_user_id:'',
                comment:'',
                seen: 'Pendiente',
            },
            rules: {
                required: value => !!value || 'Campo requerido',
            },
        }),
    computed: {
        valid(){
            if(this.note.to_user_id!=''&&this.note.to_user_id!=undefined&&this.note.to_user_id!=null){
                return true
            }else{
                return false
            }
        },
        companyLists(){
            return this.entries.companies;
        },
        contactLists(){
            return this.entries.contacts;
        }, 
        usersLists(){
            return this.$store.getters['user/activeUsers'].map(user => {
                return Object.assign({}, user, { id: this.normalizeId(user.id) })
            });
        }, 
        currentUser:{
            get(){
                return this.$store.state.currentUser.user
            }
        }    
    },
    mounted(){},
    created(){
        if(this.company!=undefined){
            const companyItem = this.extractCompany(this.company)
            if(companyItem){
                this.entries.companies = this.mergeEntries(this.entries.companies, [companyItem])
                this.note.company_id = companyItem.id
            }else{
                this.note.company_id = this.normalizeId(this.resolveCompanyId(this.company))
            }
        }
    },
    watch:{
        searchCompanies(val){
            if(val == null || val === ''){
                return
            }
            if (this.isLoadingCompany) return
            this.isLoadingCompany = true
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/companies?filter[name_razon_social]='+val)
            .then(res => {
                const mapped = res.data.data.map(company => ({
                    id: this.normalizeId(company.id),
                    name: company.attributes?.name,
                    razon_social: company.attributes?.razon_social,
                    macro: company.attributes?.macro
                }))
                this.entries.companies = this.mergeEntries(this.entries.companies, mapped)
            }).finally(() => (this.isLoadingCompany = false))
        },
        searchContacts(val){
            if(val == null || val === ''){
                return
            }
            if (this.isLoadingContact) return
            this.isLoadingContact = true
            let filter = ''
            if(this.note.company_id){
                filter = 'filter[company_id]='+this.note.company_id+'&'
            }
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/contact_p?' + filter + 'filter[name]=' + val)
            .then(res => {
                this.entries.contacts = this.mergeEntries(this.entries.contacts, res.data.data)
            }).finally(() => (this.isLoadingContact = false))
        },
        'note.company_id':{
            handler(newValue, oldValue){
                if(newValue !== oldValue){
                    this.note.contact_id = ''
                    this.entries.contacts = []
                }
            }
        }
    },
    methods: {
        normalizeId(value){
            if(value === null || value === undefined || value === ''){
                return ''
            }
            return String(value)
        },
        extractCompany(company){
            if(company && company.attributes){
                return {
                    id: this.normalizeId(company.id || company.attributes.id),
                    name: company.attributes.name,
                    razon_social: company.attributes.razon_social,
                    macro: company.attributes.macro
                }
            }
            if(company && company.id){
                return company
            }
            return null
        },
        mergeEntries(current, incoming){
            const map = {}
            current.forEach(item => {
                if(item && item.id != null){
                    map[item.id] = item
                }
            })
            incoming.forEach(item => {
                if(item && item.id != null){
                    map[item.id] = item
                }
            })
            return Object.keys(map).map(id => map[id])
        },
        resolveCompanyId(company){
            if(company && typeof company === 'object'){
                return company.id
            }
            if(company !== '' && company !== null && company !== undefined){
                return Number(company)
            }
            return null
        },
        resetNote(){
            this.note = {
                company_id: this.normalizeId(this.resolveCompanyId(this.company)),
                contact_id:'',
                from_user_id:'',
                to_user_id: '',
                comment:'',
                seen: 'Pendiente',
            }
        },
        closeCreateDialogContact: function(params) {
            this.createContactDialog = params;
            this.$store.dispatch('contact/getContacts')
        },
        closeCreateDialogCompany: function(params) {
            this.createCompanyDialog = params;
            this.$store.dispatch('company/getCompanies')
        },
        permissions(permission){
            if(this.currentUser.id==1){
                return true
            }else if(this.currentUser.permissions!=undefined){
                if(this.currentUser.permissions.includes(permission)){
                    return true
                }else{
                    return false
                }
            }else{
                return false
            }
        },
        close () {
            this.resetNote()
            this.gris = false
            this.$nextTick(() => {
                this.$emit("closeCreateDialogNote", false);
            })
        },
        save(){
            this.note.from_user_id = this.normalizeId(this.currentUser.id)
            this.note.seen = 'Pendiente'
            this.gris = true
            this.$nextTick(() => {
                const payload = {
                    company_id: this.note.company_id || null,
                    contact_id: this.note.contact_id || null,
                    from_user_id: this.note.from_user_id,
                    to_user_id: this.note.to_user_id,
                    comment: this.note.comment,
                    seen: this.note.seen,
                }
                axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/notes", payload).then(response=>{
                    this.close()
                }).catch(error => {
                    this.snackbar = {
                        message: error.response.data.message,
                        color: 'error',
                        show: true
                    }
                    this.gris = false
                })
            })
        },
    },
}
</script>
<style lang="css" scoped>
.v-text-field >>> label{
    font-size: 14px!important;
}
</style>
<style>
.v-input__icon--prepend-inner i::before {
    font-size: 18px!important;
    color:#1976D2;
}
.v-text-field input, .v-label {
    font-size: 14px;
}
.v-picker__title.primary{
    display:none;
}
</style>
